import { useFeatureFlags } from "./hooks/useFeatureFlags";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import { useIncidentBanner } from "./hooks/useIncidentBanner";

export const BannerComponent = () => {
  const { t } = useTranslation("incidents", {
    keyPrefix: "banner",
  });
  const { environment } = useFeatureFlags();

  const { isApplicationHealthy, unhealthyServicesList, manualBannerText } =
    useIncidentBanner();
  return (
    <>
      {environment && environment !== "PROD" && (
        <div
          id="test-banner"
          role="status"
          className={cn("test-banner-container")}
        >
          <div className={"test-banner"} />
          <div className={cn("test-banner-content")}>-- TESTMILJØ --</div>
          <div className={"test-banner"} />
        </div>
      )}
      {(isApplicationHealthy === false || manualBannerText != null) && (
        <div
          id="incident-banner"
          role="status"
          className={cn(environment && environment !== "PROD" ? "mt-0" : "")}
        >
          {manualBannerText && <p>{manualBannerText}</p>}
          {!isApplicationHealthy && (
            <p>
              {t("message", {
                count: unhealthyServicesList?.length || 0,
                 
                service: unhealthyServicesList?.at(0),
                services: unhealthyServicesList,
              })}
            </p>
          )}
        </div>
      )}
    </>
  );
};
